import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, ModalWrapper, ModalCloseButton } from '../common';

/**
 * 약관별 내용 맵
 * termKey를 키로, 제목과 본문을 관리합니다.
 * 내용은 추후 전달 예정 — 현재는 placeholder.
 */
const TERMS_CONTENT = {
  privacy: {
    titleKey: 'common.terms_privacy_title',
    bodyKey: 'auth.signup_terms_privacy_body',
  },
  marketing: {
    titleKey: 'common.terms_marketing_title',
    bodyKey: 'auth.signup_terms_marketing_body',
  },
};

export default function TermsModal({ termKey, onClose }) {
  const { t } = useTranslation();
  const term = TERMS_CONTENT[termKey];
  const title = term?.titleKey ? t(term.titleKey) : termKey;
  const body = term?.bodyKey ? t(term.bodyKey) : undefined;

  return (
    <ModalWrapper onClose={onClose} maxWidth="modal-md">
      <div className="absolute top-4 right-4">
        <ModalCloseButton onClick={onClose} />
      </div>

      <h2 className="text-lg font-bold text-mono-900 pr-8">{title}</h2>

      <div className="min-h-[200px] text-sm text-mono-600 leading-relaxed whitespace-pre-wrap">
        {body || (
          <p className="text-mono-400 text-center py-10">{t('common.terms_preparing')}</p>
        )}
      </div>

      <Button level="level1" fullWidth onClick={onClose}>{t('common.confirm')}</Button>
    </ModalWrapper>
  );
}
